import i18n from '@/i18n'
import { filterRulesMapped } from '@/tools/filterRules'
import { enterpriseService } from '@/services/enterprise.service'
import { mapActions, mapGetters } from 'vuex'
import { DialogType, SnackbarStyle } from '@/constants/constants'
import { dialogTypes } from '@/constants/dialogTypes'
import { DialogAlertEvent, dialogUtil } from '@/tools/dialog'
import { clone } from 'ramda'
import Vue from 'vue'
import AutocompleteComponent from '@/components/commons/autocomplete/AutocompleteComponent.vue'
import { eventService } from '@/services/event.service'
import { alertEventService } from '@/services/alertEvent.service'
import { thingService } from '@/services/thing.service'
import AlertEventDialogComponent from './dialog/AlertEventDialogComponent.vue'

export default {
    name: 'AlertEventABMComponent',
    components: {
        AlertEventDialogComponent,
        AutocompleteComponent,
    },
    data: () => ({
        // headers
        tableHeaders: [],
        // reglas de filtrado
        tableFilterRules: {},
        // datos
        tableData: [],
        // key de los datos
        tableDataKey: 'id',
        // botones de cada fila
        rowActions: [
            // eliminar
            {
                id: 1,
                name: i18n.t('delete'),
                color: 'red',
                icon: 'fa-trash-alt'
            }
        ],
        // botones del componente tabla
        tableComponentButtons: [],
        // tamaño de página (paginador)
        pageSize: 0,
        // número de página (paginador)
        pageNumber: 1,
        // total de documentos de la base de datos (paginador)
        pageTotal: 0,
        // configuración del dialog del ABM
        dialog: {
            ...dialogTypes.ALERT_EVENT,
        },
        // boolean para activar el dialogo
        showDialog: false,
        // para activar el loading de la tabla
        loading: true,
        // arreglo de empresas para el selector de la tabla
        tableEnterpriseItems: [],
        // empresa seleccionada para filtrar las cosas de la tabla
        tableEnterpriseSelected: null,
        // arreglo de empresas para el selector de la tabla
        tableTypeItems: [],
        // tipo seleccionada para filtrar las cosas de la tabla
        tableTypeSelected: null,
        // tipo de evento seleccionado para filtrar las cosas de la tabla
        tableTypeEventSelected: null,
        tableTypeEventItems: [],
        // Opción 'TODOS' para el selector de empresa
        all: {
            _id: 'ALL',
            name: i18n.t('all')
        },
        // bandera para desactivar los watchers de los selectores durante la carga inicial
        initialLoad: false,
        // banderas para identificar en la carga inicial si cambiaron los selectores
        enterpriseSelector: false,
        typeSelector: false,
        typeEventSelector: false,
    }),
    computed: {
        ...mapGetters('breadcrumbs', [
            'getBread'
        ]),
        /**
         * Devuelve un arreglo de empresas de acuerdo al valor del selector
         */
        abmSelectedEnterprises () {
            if (this.tableEnterpriseSelected) {
                if (this.tableEnterpriseSelected === 'ALL') {
                    return this.tableEnterpriseItems.filter(item => item._id !== 'ALL').map(item => item._id)
                } else {
                    return [this.tableEnterpriseSelected]
                }
            } else {
                return null
            }
        },
        /**
         * Devuelve un arreglo de tipos de acuerdo al valor del selector
         */
        abmSelectedTypes () {
            if (this.tableTypeSelected) {
                if (this.tableTypeSelected._id === 'ALL') {
                    return this.tableTypeItems.filter(item => item._id !== 'ALL').map(item => item._id)
                } else {
                    return [this.tableTypeSelected._id]
                }
            } else {
                return null
            }
        },
        /**
         * Devuelve un arreglo de tipos de eventos de acuerdo al valor del selector
         */
        abmSelectedTypesEvents () {
            if (this.tableTypeEventSelected) {
                if (this.tableTypeEventSelected._id === 'ALL') {
                    return this.tableTypeEventItems.filter(item => item._id !== 'ALL').map(item => item._id)
                } else {
                    return [this.tableTypeEventSelected._id]
                }
            } else {
                return null
            }
        },
        /**
         * 
         */
        enterprises() {
            return this.tableEnterpriseItems.filter(items => items._id !== this.all._id)
        }
    },
    created() {
        /*
            Vuex watch del breadcrumb
        */
        this.unwatch = this.$store.watch(
            (state, getters) => getters['breadcrumbs/getBread'],
                (newBreads) => {
                    const lastElemet = newBreads[newBreads.length - 1]
                    if (!lastElemet) {
                        this.cancel()
                        return
                    }
                    this.dialog = dialogUtil.getDialog(lastElemet.key, DialogAlertEvent)
                },
            { deep: true })
    },
    beforeDestroy() {
        // elimino la instancia del watcher del breadcrumb
        this.unwatch()
        this.cleanBread()
    },
    async mounted() {
        // Botones de edición y eliminación múltiple
        this.tableComponentButtons.push(            
            {
                id: 'add-dialog',
                tooltip: i18n.t('add'),
                icon: 'add',
                action: this.showCreateDialog.bind(this),
                selectedData: false
            },
            {
                id: 'masive-delete',
                tooltip: i18n.t('multipleDelete'),
                icon: 'delete_outline',
                action: this.deleteMany.bind(this),
                selectedData: true
            })
        await this.initialize()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread',
            'cleanBread'
        ]),
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * Inicialización del breadcrumb para alta/modificación
         */
        initBread() {
            const bread = {
                key: dialogTypes.ALERT_EVENT.key,
                disabled: true,
                text: this.$t('alertEvent.name')
            }
            this.pushBread(bread)
        },
        /**
         * Este método se ejecuta para inicializar los datos de la tabla.
         * Carga el selector de empresas y el selector de tipos y ejecuta el método para cargar los datos de la tabla.
         */
        async initialize () {
            this.initialLoad = true

            // inicialización de los datos de selectores

            // tipos de equipos
            const types = await thingService.getTypesForSelector()
            if (types.length > 1) {
                this.tableTypeItems = [this.all]
                this.tableTypeItems = this.tableTypeItems.concat(this.tableTypeItems, types)
            } else {
                this.tableTypeItems = types
            }
            this.typesItems = types
            this.tableTypeSelected = this.tableTypeItems.length > 0 ? this.tableTypeItems[0] : null

            // tipos de eventos
            const typesEvents = await eventService.findAllForSelector()
            const lang = localStorage.getItem('locale')
            typesEvents.forEach(t => t.name = t.name[lang])

            if (typesEvents.length > 1) {
                this.tableTypeEventItems = [this.all]
                this.tableTypeEventItems = this.tableTypeEventItems.concat(this.tableTypeEventItems, typesEvents)
            } else {
                this.tableTypeEventItems = typesEvents
            }
            this.typesEventItems = types
            this.tableTypeEventSelected = this.tableTypeEventItems.length > 0 ? this.tableTypeEventItems[0] : null

            // empresas
            const enterprises = await enterpriseService.getAllForSelector()
            this.tableEnterpriseItems = enterprises
            this.tableEnterpriseSelected = this.tableEnterpriseItems.length > 0 ? this.tableEnterpriseItems[0]._id : null

            // total de cosas
            this.pageTotal = await alertEventService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes, this.abmSelectedTypesEvents)

            // Si hay query params, los setea para incluirlos en la llamada al backend
            if (this.$route.query.pageSize && this.$route.query.pageNumber) {
                this.pageSize = Number(this.$route.query.pageSize)
                this.pageNumber = Number(this.$route.query.pageNumber)

                // Valida que los query params sean correctos y completos
                if ((this.pageSize && this.pageSize <= 0) || (this.pageNumber && this.pageNumber <= 0) || (this.pageNumber && !this.pageSize) || (!this.pageNumber && this.pageSize)) {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('error.invalidQueryParams'),
                        timeout: 6000,
                        style: SnackbarStyle.ERROR
                    })
                    this.pageSize = this.pageTotal
                    this.pageNumber = 1
                }
            } else {
                this.pageSize = this.pageTotal
                this.pageNumber = 1
            }

            // cargo la tabla con las cosas filtradas de acuerdo a los valores del selector
            await this.getData()
            this.resetFields()
            this.initBread()
            this.initialLoad = false
        },
        /**
         * Este método se utiliza para obtener los datos de la tabla
         * @param {*} update
         */
        async getData(update = false) {
            this.loading = true
            if (update) {
                this.pageTotal = await alertEventService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes, this.abmSelectedTypesEvents)
                this.pageSize = this.pageSize ?? 50;
                this.pageNumber = this.pageNumber ?? 1;
            }
            let data = await alertEventService.findAll(this.pageSize, this.pageNumber, this.abmSelectedEnterprises, this.abmSelectedTypes, this.abmSelectedTypesEvents)
            
            if (this.enterpriseSelector || this.typeSelector || this.typeEventSelector) {
                this.enterpriseSelector = false
                this.typeSelector = false
                this.typeEventSelector = false

                this.pageTotal = await alertEventService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes, this.abmSelectedTypesEvents)
                this.pageSize = this.pageSize ?? 50;
                this.pageNumber = this.pageNumber ?? 1;

                data = await alertEventService.findAll(this.pageSize, this.pageNumber, this.abmSelectedEnterprises, this.abmSelectedTypes, this.abmSelectedTypesEvents)
            }
            // Se clonan los headers anteriores para mantener las columnas seleccionadas
            const lastTableHeaders = clone(this.tableHeaders)
            this.tableData.cleanAndUpdate(data.data)
            if (update) {
                const that = this
                Vue.nextTick(function () {
                    that.tableHeaders.cleanAndUpdate(lastTableHeaders)
                })
            } else {
                this.tableHeaders.cleanAndUpdate(data.headers)
                this.setTableFilterRules()
            }
            this.loading = false
        },
        /**
         * Refrescar la data
         */
        async refreshTable() {
            await this.getData(true)
        },
        /**
         * Reglas de filtrado de la tabla
         */
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
        /**
         * Reset el modelo del dialog de creación
         */
        resetFields() {
            if (this.dialog) {
                this.dialog.model = {
                    _id: null,
                    thingIds: null,
                    thingsData: null,
                    userIds: null,
                    usersData: null,
                    eventIds: null,
                    eventsData: null,
                }
            }
        },
        /**
         * Eliminar un equipo
         * @param {*} id
         */
        deleteOne(id) {
            alertEventService.deleteOne(id).then(() => {
                this.showSnackbar({
                    visible: true,
                    text: this.$t('alertEvent.successDeleteOneMessage'),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS
                })
                this.getData(true)
            })
        },
        /**
         * Eliminar muchos equipos
         * @param {*} data
         */
        async deleteMany(data) {
            this.openDialog({
                title: this.$t('alertEvent.deleteManyTitle'),
                text: this.$t('alertEvent.multipleDeleteText'),
                type: DialogType.QUESTION,
                overlayOpacity: 0.5,
                actionButtons: true,
                yesAction: async () => {
                    alertEventService.deleteMany(data.map(element => element.id)).then(() => {
                        this.showSnackbar({
                            visible: true,
                            text: this.$t('alertEvent.successDeleteManyMessage'),
                            timeout: 6000,
                            style: SnackbarStyle.SUCCESS
                        })
                        this.getData(true)
                    })
                },
                noAction: () => {
                }
            })
        },
        /**
         * Acción de los botones de cada fila (eliminar)
         * @param {*} button
         * @param {*} data
         */
        rowButtonClicked(button, data) {
            switch (button.id) {
                case 1:
                    this.openDialog({
                        title: this.$t('alertEvent.deleteOneTitle'),
                        text: this.$t('alertEvent.deleteOneText', { name: data.thingName }),
                        type: DialogType.QUESTION,
                        overlayOpacity: 0.5,
                        actionButtons: true,
                        yesAction: () => {
                            this.deleteOne(data.id)
                        },
                        noAction: () => {
                        }
                    })
                    break
                default:
                    console.error('Botón no implementado')
            }
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.resetFields()
            this.showDialog = false
        },
        /**
         * Abre el dialog para creación
         */
        showCreateDialog() {
            this.initBread()
            // TODO revisar esto
            if (!this.dialog) {
                this.dialog = {...dialogTypes.ALERT_EVENT}
            }
            this.dialog.model.enterpriseIds = this.tableEnterpriseItems
            this.editDialogTitle= i18n.t('alertEvent.editDialog.titleNew')
            this.showDialog = true
        },
        /**
         * Paginador externo
         * @param {*} pageSize
         * @param {*} pageNumber
         */
        externalPaginator(pageSize, pageNumber) {
            this.pageNumber = Number(pageNumber)
            this.pageSize = Number(pageSize)
        },
        /**
         * Esta función se ejecuta cuando alguno de los selectores (empresa o tipo) cambia
         */
        async updateData() {
            // total de cosas
            this.pageTotal = await alertEventService.getTotal(this.abmSelectedEnterprises, this.abmSelectedTypes, this.abmSelectedTypesEvents)
            this.pageSize = this.pageTotal
            this.pageNumber = 1
            // datos
            await this.getData(true)
        },
        /**
         * Cuando se selecciona una empresa
         * @param {*} newValue
         */
        tableEnterpriseSelectedFunction (newValue) {
            /* initialLoad es una bandera que indica cuando se está realizando
                la carga inicial de los datos de la tabla
            */
            this.tableEnterpriseSelected = newValue._id ? newValue._id : newValue;
            if (!this.initialLoad) {
                this.updateData()
            } else {
                this.enterpriseSelector = true
            }
        },
        /**
         * Cuando se selecciona un tipo de equipo
         * @param {*} newValue
         */
        tableTypeSelectedFunction (newValue) {
            /* initialLoad es una bandera que indica cuando se está realizando
                la carga inicial de los datos de la tabla
            */
            this.tableTypeSelected = newValue;
            if (!this.initialLoad) {
                this.updateData()
            } else {
                this.typeSelector = true
            }
        },
        /**
         * Cuando se selecciona un tipo de evento
         * @param {*} newValue
         */
        tableTypeEventSelectedFunction (newValue) {
            /* initialLoad es una bandera que indica cuando se está realizando
                la carga inicial de los datos de la tabla
            */
            this.tableTypeEventSelected = newValue;
            if (!this.initialLoad) {
                this.updateData()
            } else {
                this.typeEventSelector = true
            }
        }
    },
}
